import type { TableSelectedCell } from '@/components/custom/erp';
import type { PhiNganHangGiayBaoNo } from '@/types/schemas';
import { useTableRows } from '@/components/custom/erp';

export type SelectedCellInfo = TableSelectedCell;

export interface PhiNganHangRow extends Omit<PhiNganHangGiayBaoNo, 'uuid' | 'ma_cpnh_data' | 'ma_thue_data'> {
  uuid: string;
  line?: number;
  ma_cpnh_data?:
    | (NonNullable<PhiNganHangGiayBaoNo['ma_cpnh_data']> & {
        ma_thue_data?:
          | (NonNullable<PhiNganHangGiayBaoNo['ma_thue_data']> & {
              thue_suat?: PhiNganHangGiayBaoNo['thue_suat'];
            })
          | null;
      })
    | null;
  ma_thue_data?:
    | (NonNullable<PhiNganHangGiayBaoNo['ma_thue_data']> & {
        thue_suat?: PhiNganHangGiayBaoNo['thue_suat'];
      })
    | null;
}

export function usePhiNganHangRows(
  initialRows: PhiNganHangRow[] = [],
  onChange?: (rows: PhiNganHangRow[]) => void,
  onFieldValueChange?: (row: PhiNganHangRow, field: string, value: unknown) => Partial<PhiNganHangRow>
) {
  const {
    rows,
    setRows,
    selectedRowUuid,
    setSelectedRowUuid,
    selectedRow,
    setSelectedRow,
    selectedCell,
    setSelectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleCellValueChange,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handleMoveRow,
    handlePasteRow,
    setNonWritableFields,
    setPasteConfigs,
    isPasting
  } = useTableRows<PhiNganHangRow>({
    initialRows,
    onChange,
    onFieldValueChange,
    defaultField: 'dien_giai'
  });

  return {
    rows,
    setRows,
    selectedRowUuid,
    setSelectedRowUuid,
    selectedRow,
    setSelectedRow,
    selectedCell,
    setSelectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleCellValueChange,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handlePasteRow,
    handleMoveRow,
    setNonWritableFields,
    setPasteConfigs,
    isPasting
  };
}
